import { useQuery } from "@tanstack/react-query";
import tagService from "../api/tagService";

export const useTags = () => {
  const { getTags } = tagService();

  return useQuery({
    queryKey: ["get-tags"],
    queryFn: async () => {
      const res = await getTags();
      return res.data;
    },
  });
};
